import { ContentImage } from '@frontend/vanilla/core';

import { ResultsPrize } from '../../common/models/results/results-prize';

export class PlayerReward {
    rewardId: number;
    rewardValue: string;
    rewardDescription: string;
    rewardType: string;
    rewardListDescription: string;
    rewardTnc: string;
    resultPrize: ResultsPrize;
    rewardStatus: string;
    isRewardSelected: boolean;
    rewardImage: string;
    rewardBackgroundImage: ContentImage;
}
